"use strict";
import "../../images/decidim/placeholder-card-g.svg";
import "../../images/decidim/proposals/proposal-placeholder-card-g.svg";
const images = require.context("../../images", true);
